export const perPortionPrice = 2.98
export const defaultMetaImageLink =
  'https://production-media.gousto.co.uk/cms/promo-image/5c38625bdc0e82003eaf3737-1125x750.jpg'
